(function () {
  "use strict";

  var IRONVX_PRODUCT_URL = "/products/ironvx-one-home-gym";

  (function legacyProductRedirect() {
    var path = (window.location.pathname || "").replace(/\/+$/, "") || "/";
    if (path !== "/products/ironvx" && path !== "/product/flexcore-x1-all-in-one-smart-portable-gym") return;
    var el = document.querySelector("[data-product-url]");
    var target = (el && el.getAttribute("data-product-url")) || IRONVX_PRODUCT_URL;
    window.location.replace(target);
  })();

  function fixIronvxNavLinks() {
    document.querySelectorAll("a").forEach(function (link) {
      var label = (link.textContent || "").trim();
      if (label !== "IronVX") return;
      var href = link.getAttribute("href") || "";
      if (!href || href === "#" || href === window.location.pathname) {
        link.setAttribute("href", IRONVX_PRODUCT_URL);
      }
    });
  }

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function route(key, fallback) {
    var routes = window.IronvxRoutes ||
      ((window.Shopify && window.Shopify.routes) || {});
    return routes[key] || fallback;
  }

  function appendJsonEndpoint(path) {
    return String(path || "").replace(/\/+$/, "") + ".js";
  }

  function formatCountdown(ms) {
    if (ms <= 0) return "00:00:00";
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    var timePart = [h, m, sec].map(function (n) {
      return String(n).padStart(2, "0");
    }).join(":");
    if (d > 0) {
      return d + "d " + timePart;
    }
    return timePart;
  }

  function initCountdown() {
    var end = localStorage.getItem("ironvx-launch-end-30d");
    var now = Date.now();
    if (!end || Number(end) <= now) {
      var d = new Date();
      d.setDate(d.getDate() + 30);
      d.setHours(23, 59, 59, 0);
      end = String(d.getTime());
      localStorage.setItem("ironvx-launch-end-30d", end);
    }
    var target = Number(end);
    function tick() {
      var timeDiff = target - Date.now();
      if (timeDiff <= 0) {
        timeDiff = 0;
      }
      var text = formatCountdown(timeDiff);
      $$(".ironvx-countdown").forEach(function (el) {
        el.textContent = text;
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  function closeMobileMenu(btn, menu) {
    if (!btn || !menu) return;
    menu.hidden = true;
    btn.setAttribute("aria-expanded", "false");
  }

  function initMobileMenu() {
    var btn = $("#ironvx-mobile-menu-btn");
    var menu = $("#ironvx-mobile-menu");
    if (!btn || !menu) return;
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = menu.hidden;
      menu.hidden = !open;
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("click", function (e) {
      if (menu.hidden) return;
      if (!menu.contains(e.target) && e.target !== btn && !btn.contains(e.target)) {
        closeMobileMenu(btn, menu);
      }
    });
    $$(".ironvx-mobile-link", menu).forEach(function (link) {
      link.addEventListener("click", function () {
        closeMobileMenu(btn, menu);
      });
    });
    window.addEventListener("resize", function () {
      if (window.matchMedia("(min-width: 768px)").matches) {
        closeMobileMenu(btn, menu);
      }
    });
  }

  function initLocaleMenu() {
    var btn = $("#ironvx-locale-btn");
    var menu = $("#ironvx-locale-menu");
    if (!btn || !menu) return;
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      menu.hidden = !menu.hidden;
      btn.setAttribute("aria-expanded", menu.hidden ? "false" : "true");
    });
    document.addEventListener("click", function (e) {
      if (menu.hidden) return;
      if (menu.contains(e.target) || btn.contains(e.target)) return;
      menu.hidden = true;
      btn.setAttribute("aria-expanded", "false");
    });
    menu.addEventListener("click", function (e) {
      e.stopPropagation();
    });
    var form = $("#ironvx-localization-form");
    if (form) {
      form.addEventListener("submit", function () {
        menu.hidden = true;
        btn.setAttribute("aria-expanded", "false");
      });
    }
  }

  function ensureToast() {
    var el = $("#ironvx-toast");
    if (el) return el;
    el = document.createElement("div");
    el.id = "ironvx-toast";
    el.setAttribute("role", "status");
    el.setAttribute("aria-live", "polite");
    el.className = "ironvx-toast";
    el.hidden = true;
    document.body.appendChild(el);
    return el;
  }

  function showToast(message) {
    var el = ensureToast();
    el.textContent = message;
    el.hidden = false;
    el.classList.add("is-visible");
    clearTimeout(showToast._timer);
    showToast._timer = setTimeout(function () {
      el.classList.remove("is-visible");
      el.hidden = true;
    }, 3200);
  }

  function updateCartBadge(count) {
    $$("[data-ironvx-cart-count]").forEach(function (el) {
      el.textContent = String(count);
      el.classList.toggle("ironvx-is-hidden", count <= 0);
    });
    var cartLink = $("[data-ironvx-cart]");
    if (!cartLink) return;
    var badge = cartLink.querySelector("[data-ironvx-cart-count]");
    if (!badge && count > 0) {
      badge = document.createElement("span");
      badge.setAttribute("data-ironvx-cart-count", "");
      badge.className = "ironvx-cart-badge";
      cartLink.appendChild(badge);
    }
    if (badge) {
      badge.textContent = String(count);
      badge.classList.toggle("ironvx-is-hidden", count <= 0);
    }
  }

  function refreshCartCount() {
    return fetch(route("root", "/") + "cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateCartBadge(cart.item_count || 0);
        return cart;
      })
      .catch(function () {});
  }

  function addToCart(variantId, options) {
    options = options || {};
    var qty = options.quantity || 1;
    var properties = options.properties || null;
    var item = { id: Number(variantId), quantity: qty };
    if (properties) {
      item.properties = properties;
    }
    var url = appendJsonEndpoint(route("cart_add", "/cart/add"));
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: [item] }),
    })
      .then(function (r) {
        return r.text().then(function (text) {
          var data = text ? JSON.parse(text) : {};
          if (!r.ok) {
            throw new Error(data.description || data.message || "Add to cart failed");
          }
          return data;
        });
      })
      .then(function (data) {
        if (data.status && data.status >= 400) {
          throw new Error(data.description || data.message || "Add to cart failed");
        }
        return refreshCartCount().then(function () {
          return data;
        });
      });
  }

  function handleCartSuccess(action, productName) {
    var name = productName ? " — " + productName : "";
    if (action === "buy") {
      window.location.href = "/checkout";
      return;
    }
    if (action === "cart") {
      window.location.href = route("cart", "/cart");
      return;
    }
    showToast("Added to cart" + name);
  }

  function setButtonLoading(btn, loading, label) {
    if (!btn) return;
    if (loading) {
      btn.dataset.ironvxLabel = btn.textContent.trim();
      btn.disabled = true;
      btn.textContent = "Adding…";
      return;
    }
    btn.disabled = false;
    btn.textContent = label || btn.dataset.ironvxLabel || btn.textContent;
  }

  function getSelectedVariantId() {
    var sel = $("#ironvx-variant-id");
    if (sel && sel.value) return sel.value;
    var data = $("#ironvx-product-data");
    if (!data) return null;
    try {
      var parsed = JSON.parse(data.textContent);
      return String(parsed.defaultVariant || parsed.selected);
    } catch (e) {
      return null;
    }
  }

  function initProductPage() {
    var root = $(".ironvx-product-page");
    if (!root) return;

    var hero = $(".product-detail-hero-image", root);
    var thumbs = $$(".product-detail-hero-surface + .grid button, .grid.grid-cols-4.gap-3 button", root);
    if (!thumbs.length) thumbs = $$(".grid.grid-cols-4 button", root);
    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var img = $("img", btn);
        if (!img || !hero) return;
        hero.removeAttribute("srcset");
        hero.src = btn.dataset.ironvxHeroSrc || img.src;
        hero.alt = img.alt || hero.alt;
        thumbs.forEach(function (b) {
          b.classList.remove("border-accent", "shadow-glow", "scale-[1.02]");
          b.classList.add("border-border/60", "opacity-80");
        });
        btn.classList.add("border-accent", "shadow-glow", "scale-[1.02]");
        btn.classList.remove("border-border/60", "opacity-80");
      });
    });

    var dataEl = $("#ironvx-product-data");
    var variants = [];
    var bundle = "Standard";
    var color = "Black";
    if (dataEl) {
      try {
        var parsed = JSON.parse(dataEl.textContent);
        variants = parsed.variants || [];
        var defaultVariantId = parsed.defaultVariant;
        var matchedDefault = variants.find(function(v) {
          return v.id === defaultVariantId;
        });
        if (matchedDefault) {
          bundle = matchedDefault.bundle || bundle;
          color = matchedDefault.color || color;
        }
      } catch (e) {}
    }

    function formatInstallment(formattedPrice, cents) {
      var installmentCents = Math.round(cents / 3);
      var installmentValue = (installmentCents / 100).toFixed(2);
      if (formattedPrice.indexOf(",") !== -1) {
        var parts = installmentValue.split(".");
        installmentValue = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + parts[1];
      } else if (formattedPrice.indexOf(".") !== -1) {
        var parts = installmentValue.split(".");
        installmentValue = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + parts[1];
      } else {
        installmentValue = Math.round(installmentCents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      var prefix = formattedPrice.match(/^[^\d]*/)[0];
      var suffix = formattedPrice.match(/[^\d]*$/)[0];
      var hasDecimals = /[\.,]\d{2}[^\d]*$/.test(formattedPrice);
      if (!hasDecimals) {
        installmentValue = installmentValue.split(/[\.,]/)[0];
      }
      return prefix + installmentValue + suffix;
    }

    function pickVariant() {
      var match = variants.find(function (v) {
        return v.bundle === bundle && v.color === color;
      });
      if (match) {
        var sel = $("#ironvx-variant-id");
        if (sel) sel.value = match.id;
        $$(".ironvx-price-main", root).forEach(function (el) {
          el.textContent = match.priceFormatted || el.textContent;
        });
        var installmentEl = $(".ironvx-installment-amount", root);
        if (installmentEl && match.priceFormatted && match.price) {
          installmentEl.textContent = formatInstallment(match.priceFormatted, match.price);
        }
        $$(".ironvx-price-compare", root).forEach(function (el) {
          if (match.compareFormatted) el.textContent = match.compareFormatted;
        });
        $$(".ironvx-sticky-price").forEach(function (el) {
          el.textContent = match.priceFormatted || el.textContent;
        });
        var bundleLabel = $(".ironvx-selected-bundle", root);
        if (bundleLabel) bundleLabel.textContent = bundle;
        var colorLabel = $(".ironvx-selected-color", root);
        if (colorLabel) colorLabel.textContent = color;
        if (match.image && hero) {
          hero.src = match.image;
        }
        var stickyBar = $("#ironvx-global-sticky-bar");
        if (stickyBar) {
          $$("[data-variant-id]", stickyBar).forEach(function (btn) {
            btn.setAttribute("data-variant-id", match.id);
          });
        }
      }
    }

    function setBundleButtonState(btn, active) {
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      btn.classList.toggle("ring-2", active);
      btn.classList.toggle("ring-accent", active);
      btn.classList.toggle("bg-accent/10", active);
      btn.classList.toggle("shadow-glow", active);
      btn.classList.toggle("scale-[1.02]", active);
      btn.classList.toggle("border-accent", active);
      btn.classList.toggle("opacity-60", !active);
      btn.classList.toggle("hover:opacity-100", !active);
      btn.classList.toggle("hover:-translate-y-0.5", !active);
      btn.classList.toggle("hover:ring-1", !active);
      btn.classList.toggle("hover:ring-accent/40", !active);
      var check = $(".ironvx-bundle-check", btn);
      if (check) check.classList.toggle("hidden", !active);
      var selected = $(".ironvx-bundle-selected", btn);
      if (selected) selected.classList.toggle("hidden", !active);
      var price = $(".ironvx-bundle-price", btn);
      if (price) price.classList.toggle("text-accent", active);
    }

    function setColorButtonState(btn, active) {
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      btn.classList.toggle("border-accent", active);
      btn.classList.toggle("bg-accent/10", active);
      btn.classList.toggle("border-border", !active);
      var check = $(".ironvx-color-check", btn);
      if (check) check.classList.toggle("hidden", !active);
    }

    $$("[data-ironvx-bundle]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        bundle = btn.getAttribute("data-ironvx-bundle");
        $$("[data-ironvx-bundle]", root).forEach(function (b) {
          setBundleButtonState(b, b === btn);
        });
        pickVariant();
      });
    });
    $$("[data-ironvx-color]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        color = btn.getAttribute("data-ironvx-color");
        $$("[data-ironvx-color]", root).forEach(function (b) {
          setColorButtonState(b, b === btn);
        });
        pickVariant();
      });
    });
    // Initialize swatch and bundle button active states to match default selected option values
    $$("[data-ironvx-bundle]", root).forEach(function (b) {
      setBundleButtonState(b, b.getAttribute("data-ironvx-bundle") === bundle);
    });
    $$("[data-ironvx-color]", root).forEach(function (b) {
      setColorButtonState(b, b.getAttribute("data-ironvx-color") === color);
    });
    pickVariant();

    $$("[data-ironvx-action]", root).forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var action = btn.getAttribute("data-ironvx-action");
        var vid = btn.getAttribute("data-variant-id") || getSelectedVariantId();
        if (!vid) {
          showToast("Please select a product option");
          return;
        }
        var opts = { quantity: 1 };
        var upsellCheckbox = $("#ironvx-warranty-upsell", root);
        if (upsellCheckbox && upsellCheckbox.checked) {
          opts.properties = { "Warranty": "2-Year Extended Protection (+$49)" };
        }
        setButtonLoading(btn, true);
        addToCart(vid, opts)
          .then(function () {
            handleCartSuccess(action === "buy" ? "buy" : "cart");
          })
          .catch(function (err) {
            showToast(err.message || "Could not add to cart");
          })
          .finally(function () {
            setButtonLoading(btn, false);
          });
      });
    });

    $$("[data-ironvx-accessory-cart]", root).forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var card = btn.closest(".ironvx-accessory-card");
        var titleEl = card ? $(".font-display.font-bold.text-base", card) : null;
        var title = titleEl ? titleEl.textContent.trim() : "";
        var variantId = btn.getAttribute("data-variant-id");
        if (!variantId) {
          showToast("This accessory is unavailable");
          return;
        }
        setButtonLoading(btn, true);
        addToCart(variantId, { quantity: 1 })
          .then(function () {
            handleCartSuccess("toast", title);
          })
          .catch(function (err) {
            showToast(err.message || "Could not add to cart");
          })
          .finally(function () {
            setButtonLoading(btn, false);
          });
      });
    });

    var video = $("video", root);
    if (video) {
      video.addEventListener("error", function () {
        var fallback = video.getAttribute("data-fallback-src");
        if (fallback && video.src !== fallback) video.src = fallback;
      });
    }
  }

  function initStickyBar() {
    var bar = $("#ironvx-global-sticky-bar");
    if (!bar) return;

    var isVisible = false;

    function handleScroll() {
      var currY = window.scrollY;
      var shouldShow = currY > 300;
      if (shouldShow !== isVisible) {
        isVisible = shouldShow;
        bar.classList.toggle("is-visible", isVisible);
        document.body.classList.toggle("has-sticky-bar-visible", isVisible);
      }
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Check initial scroll position

    $$("[data-ironvx-action]", bar).forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var action = btn.getAttribute("data-ironvx-action");
        var vid = getSelectedVariantId() || btn.getAttribute("data-variant-id");
        if (!vid) {
          showToast("Please select a product option");
          return;
        }
        setButtonLoading(btn, true);
        addToCart(vid, { quantity: 1 })
          .then(function () {
            handleCartSuccess(action === "buy" ? "buy" : "cart");
          })
          .catch(function (err) {
            showToast(err.message || "Could not add to cart");
          })
          .finally(function () {
            setButtonLoading(btn, false);
          });
      });
    });
  }

  function initCartPage() {
    var page = $(".ironvx-cart-page");
    if (!page) return;

    function getQtyValue(el) {
      if (!el) return 0;
      return Number(el.value || el.textContent || 0);
    }

    $$("[data-ironvx-qty-minus]", page).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var key = btn.getAttribute("data-line-key");
        var qtyEl = $('[data-line-key="' + key + '"][data-ironvx-qty-input]', page);
        if (!qtyEl) return;
        updateLine(key, Math.max(0, getQtyValue(qtyEl) - 1));
      });
    });
    $$("[data-ironvx-qty-plus]", page).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var key = btn.getAttribute("data-line-key");
        var qtyEl = $('[data-line-key="' + key + '"][data-ironvx-qty-input]', page);
        if (!qtyEl) return;
        updateLine(key, getQtyValue(qtyEl) + 1);
      });
    });
    $$("[data-ironvx-remove-line]", page).forEach(function (btn) {
      btn.addEventListener("click", function () {
        updateLine(btn.getAttribute("data-line-key"), 0);
      });
    });

    function updateLine(key, quantity) {
      fetch(route("root", "/") + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          showToast("Could not update cart");
        });
    }

  }

  function initBlog() {
    var page = $(".ironvx-blog-page");
    if (!page) return;
    var search = $("#ironvx-blog-search");
    var cards = $$(".ironvx-blog-card", page);
    var countEl = $("#ironvx-blog-count");
    var filters = $$(".ironvx-blog-filter", page);
    var activeFilter = "all";

    function applyFilters() {
      var q = search ? search.value.trim().toLowerCase() : "";
      var visible = 0;
      cards.forEach(function (card) {
        var title = (card.getAttribute("data-title") || card.textContent || "").toLowerCase();
        var tags = card.getAttribute("data-tags") || "";
        var matchSearch = !q || title.indexOf(q) !== -1;
        var matchTag = activeFilter === "all" || tags.indexOf(activeFilter) !== -1;
        var show = matchSearch && matchTag;
        card.style.display = show ? "" : "none";
        if (show) visible++;
      });
      if (countEl) countEl.textContent = visible + " article" + (visible === 1 ? "" : "s");
    }

    if (search) {
      search.addEventListener("input", applyFilters);
      document.addEventListener("keydown", function (e) {
        if (e.key === "/" && document.activeElement !== search) {
          e.preventDefault();
          search.focus();
        }
      });
    }

    filters.forEach(function (btn) {
      btn.addEventListener("click", function () {
        activeFilter = btn.getAttribute("data-blog-filter") || "all";
        filters.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle("bg-accent", on);
          b.classList.toggle("text-accent-foreground", on);
          b.classList.toggle("border-accent", on);
          b.classList.toggle("bg-background/40", !on);
          b.classList.toggle("text-muted-foreground", !on);
          b.classList.toggle("border-border/60", !on);
        });
        applyFilters();
      });
    });
    applyFilters();
  }

  function initIronvxLocale() {
    if (window.__ironvxLocaleInit) return;
    window.__ironvxLocaleInit = true;

    var STORAGE_KEY = "ironvx-locale-choice";
    var SESSION_KEY = "ironvx-locale-auto-attempt-v5";
    var MANUAL_SESSION_KEY = "ironvx-locale-manual-session-v2";

    function readData() {
      var el = document.getElementById("ironvx-localization-data");
      if (el) {
        try {
          return JSON.parse(el.textContent);
        } catch (e) {}
      }
      var countrySelect = document.getElementById("ironvx-country-code");
      var countries = [];
      if (countrySelect) {
        Array.prototype.forEach.call(countrySelect.options, function (opt) {
          var match = opt.textContent.match(/\(([A-Z]{3})\)\s*$/);
          countries.push({
            iso: opt.value,
            name: opt.textContent.replace(/\s*\([A-Z]{3}\)\s*$/, "").trim(),
            currency: match ? match[1] : ""
          });
        });
      }
      var localeChip = document.querySelector("#ironvx-locale-btn span.uppercase");
      var currencyChip = document.querySelector("#ironvx-locale-btn span.hidden.sm\\:inline");
      var currentCountry = countrySelect ? countrySelect.value : "US";
      return {
        locale: localeChip ? localeChip.textContent.trim() : "en",
        country: currentCountry,
        countryName: currentCountry,
        currency: currencyChip ? currencyChip.textContent.trim() : "USD",
        localizationUrl: "/localization",
        autoRedirect: false,
        autoCountry: true,
        bannerEnabled: true,
        availableLocales: ["en"],
        availableCountries: countries
      };
    }

    function readChoice() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        if (raw.charAt(0) !== "{") return { source: raw };
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    }

    function markChoice(source, extra) {
      try {
        var payload = { source: source, ts: Date.now() };
        if (extra) {
          Object.keys(extra).forEach(function (key) {
            payload[key] = extra[key];
          });
        }
        localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      } catch (e) {}
    }

    function manualChoiceInSession() {
      try {
        return sessionStorage.getItem(MANUAL_SESSION_KEY) === "1";
      } catch (e) {
        return false;
      }
    }

    function markManualChoiceInSession() {
      try {
        sessionStorage.setItem(MANUAL_SESSION_KEY, "1");
      } catch (e) {
      }
    }

    function recentAutoAttempt(countryCode, localeCode) {
      try {
        var raw = sessionStorage.getItem(SESSION_KEY);
        if (!raw) return false;
        var attempt = JSON.parse(raw);
        return (
          attempt.country === countryCode &&
          attempt.locale === localeCode &&
          Date.now() - attempt.ts < 15000
        );
      } catch (e) {
        return false;
      }
    }

    function markAutoAttempt(countryCode, localeCode) {
      try {
        if (countryCode && localeCode) {
          sessionStorage.setItem(
            SESSION_KEY,
            JSON.stringify({ country: countryCode, locale: localeCode, ts: Date.now() })
          );
        }
      } catch (e) {}
    }

    function clearAutoAttempt() {
      try {
        sessionStorage.removeItem(SESSION_KEY);
      } catch (e) {}
    }

    function isEnglish(locale) {
      return !locale || locale === "en" || locale.indexOf("en-") === 0;
    }

    function localeAvailable(code, data) {
      if (!code || !data || !data.availableLocales) return false;
      return data.availableLocales.indexOf(code) !== -1;
    }

    function countryAvailable(iso, data) {
      if (!iso || !data || !data.availableCountries) return false;
      return data.availableCountries.some(function (c) {
        return c.iso === iso;
      });
    }

    function returnPath() {
      return window.location.pathname + window.location.search + window.location.hash;
    }

    function submitLocalization(localeCode, countryCode, data) {
      var form = document.createElement("form");
      form.method = "post";
      form.action = (data && data.localizationUrl) || "/localization";
      form.style.display = "none";

      function field(name, value) {
        if (value == null || value === "") return;
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        form.appendChild(input);
      }

      field("form_type", "localization");
      field("utf8", "✓");
      field("_method", "put");
      field("return_to", (data && data.returnTo) || returnPath());

      var tokenEl = document.querySelector('input[name="authenticity_token"]');
      if (tokenEl) {
        field("authenticity_token", tokenEl.value);
      }

      if (localeCode) {
        field("language_code", localeCode);
      }
      if (countryCode) field("country_code", countryCode);

      document.body.appendChild(form);
      form.submit();
    }

    function fetchSuggestions(data) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      var query =
        "browsing_context_suggestions.json?country%5Benabled%5D=true" +
        "&country%5Bexclude%5D=" + encodeURIComponent(data.country || "") +
        "&language%5Benabled%5D=true" +
        "&language%5Bexclude%5D=" + encodeURIComponent(data.locale || "");
      return fetch(root + query, {
        credentials: "same-origin"
      })
        .then(function (r) {
          return r.json();
        })
        .catch(function () {
          return null;
        });
    }

    function suggestionFromResponse(payload) {
      if (!payload) return null;
      var parts = payload.suggestions && payload.suggestions[0] && payload.suggestions[0].parts;
      var detected = payload.detected_values || {};
      var country =
        (parts && parts.country && parts.country.handle) ||
        (detected.country && detected.country.handle) ||
        null;
      var countryName =
        (parts && parts.country && parts.country.name) ||
        detected.country_name ||
        country;
      var language = parts && parts.language && parts.language.handle;
      return { country: country, countryName: countryName, language: language };
    }

    function pickLanguage(data, suggestion) {
      var countryLocale = {
        AT: "de",
        DE: "de",
        LI: "de",
        AR: "es",
        BO: "es",
        CL: "es",
        CO: "es",
        CR: "es",
        DO: "es",
        EC: "es",
        SV: "es",
        ES: "es",
        GT: "es",
        HN: "es",
        MX: "es",
        NI: "es",
        PA: "es",
        PY: "es",
        PE: "es",
        UY: "es",
        VE: "es",
        FR: "fr",
        BE: "fr",
        LU: "fr",
        MC: "fr",
        IT: "it",
        SM: "it",
        NL: "nl",
        BR: "pt-BR",
        PT: "pt-BR",
        TR: "tr"
      };
      var localeForCountry = countryLocale[suggestion.country];
      if (localeForCountry && localeAvailable(localeForCountry, data)) {
        return localeForCountry;
      }
      if (suggestion.language && localeAvailable(suggestion.language, data)) {
        return suggestion.language;
      }
      var nav = (navigator.language || navigator.userLanguage || "").toLowerCase();
      if (!nav) return null;
      var base = nav.split("-")[0];
      var candidates = [nav.replace("_", "-"), base];
      if (base === "pt") candidates.push(nav.indexOf("br") !== -1 ? "pt-BR" : "pt-PT");
      if (base === "zh") candidates.push(nav.indexOf("tw") !== -1 || nav.indexOf("hk") !== -1 ? "zh-TW" : "zh-CN");
      for (var i = 0; i < candidates.length; i++) {
        if (localeAvailable(candidates[i], data)) return candidates[i];
      }
      return null;
    }

    function updateBannerCopy(suggestion) {
      var title = document.getElementById("ironvx-locale-banner-title");
      var body = document.getElementById("ironvx-locale-banner-body");
      if (title && suggestion.countryName) {
        title.textContent = "Shop in " + suggestion.countryName + "?";
      }
      if (body && suggestion.countryName) {
        body.textContent =
          "We detected your region as " +
          suggestion.countryName +
          ". Switch for local currency and language, or stay in English.";
      }
    }

    function shouldSwitch(data, suggestion) {
      var countryChanged =
        suggestion.country && suggestion.country !== data.country && countryAvailable(suggestion.country, data);
      var language = pickLanguage(data, suggestion);
      var languageChanged = language && language !== data.locale;
      return {
        country: countryChanged ? suggestion.country : null,
        countryName: suggestion.countryName,
        language: languageChanged ? language : null,
        needsChange: !!(countryChanged || languageChanged)
      };
    }

    function setFormApplying(form, applying) {
      if (!form) return;
      var btn = form.querySelector('[type="submit"]');
      if (!btn) return;
      if (applying) {
        if (!btn.dataset.ironvxApplyLabel) btn.dataset.ironvxApplyLabel = btn.textContent;
        btn.disabled = true;
        btn.textContent = "Applying…";
      } else if (btn.dataset.ironvxApplyLabel) {
        btn.disabled = false;
        btn.textContent = btn.dataset.ironvxApplyLabel;
      }
    }

    function isSensitivePage() {
      var path = window.location.pathname;
      return path === "/cart" || /\/checkouts\//.test(path);
    }

    function initBanner(data) {
      if (isSensitivePage()) return;

      fetchSuggestions(data).then(function (payload) {
        var suggestion = suggestionFromResponse(payload);
        if (!suggestion) return;

        var plan = shouldSwitch(data, suggestion);
        if (!plan.needsChange) {
          clearAutoAttempt();
          return;
        }

        var targetCountry = plan.country || data.country;
        var targetLocale = plan.language || data.locale;
        var savedChoice = readChoice();
        var choiceMatchesDetectedCountry =
          savedChoice && savedChoice.country && savedChoice.country === suggestion.country;
        if (manualChoiceInSession() && choiceMatchesDetectedCountry) return;

        if (data.autoRedirect && !recentAutoAttempt(targetCountry, targetLocale)) {
          markAutoAttempt(targetCountry, targetLocale);
          submitLocalization(plan.language, targetCountry, data);
          return;
        }

        if (data.autoCountry && plan.country && !recentAutoAttempt(targetCountry, targetLocale)) {
          markAutoAttempt(targetCountry, targetLocale);
          submitLocalization(null, plan.country, data);
          return;
        }

        if (!data.bannerEnabled) return;

        var banner = document.getElementById("ironvx-locale-banner");
        if (!banner) return;

        updateBannerCopy(suggestion);
        banner.hidden = false;
        banner.classList.remove("hidden");

        var accept = document.getElementById("ironvx-locale-banner-accept");
        var english = document.getElementById("ironvx-locale-banner-english");

        if (accept) {
          accept.addEventListener("click", function () {
            markChoice("manual", { country: plan.country || data.country, locale: plan.language || data.locale });
            markManualChoiceInSession();
            submitLocalization(plan.language, plan.country || data.country, data);
          });
        }
        if (english) {
          english.addEventListener("click", function () {
            markChoice("english", { country: suggestion.country || data.country, locale: "en" });
            markManualChoiceInSession();
            if (isEnglish(data.locale) && targetCountry === data.country) {
              banner.hidden = true;
              banner.classList.add("hidden");
              return;
            }
            submitLocalization("en", targetCountry, data);
          });
        }
      });
    }

    document.querySelectorAll("[data-ironvx-locale-english]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        markChoice("english", { locale: "en" });
        markManualChoiceInSession();
        setFormApplying(form, true);
        submitLocalization("en", data.country, data);
      });
    });

    document.querySelectorAll("form[action*='localization']").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var countrySelect = form.querySelector("#ironvx-country-code");
        var localeSelect = form.querySelector("#ironvx-locale-code");
        var country = countrySelect ? countrySelect.value : null;
        var locale = localeSelect ? localeSelect.value : null;
        markChoice("manual", {
          country: country,
          locale: locale
        });
        markManualChoiceInSession();
        setFormApplying(form, true);
        submitLocalization(locale, country, data);
      });
    });

    var data = readData();
    if (data) initBanner(data);
  }

  window.initIronvxLocale = initIronvxLocale;

  function initEmailPopup() {
    var popup = $("#ironvx-email-popup");
    if (!popup) return;

    var overlay = $("#ironvx-email-popup-overlay");
    var closeBtn = $("#ironvx-email-popup-close");
    var declineBtn = $("#ironvx-popup-decline");
    var form = $("#ironvx-popup-form");

    // Check if dismissed or submitted in the past
    if (localStorage.getItem("ironvx-email-captured")) {
      return;
    }

    function dismissPopup() {
      popup.classList.remove("is-visible");
      setTimeout(function () {
        popup.classList.add("hidden");
      }, 400);
      localStorage.setItem("ironvx-email-captured", "dismissed");
    }

    if (closeBtn) closeBtn.addEventListener("click", dismissPopup);
    if (declineBtn) declineBtn.addEventListener("click", dismissPopup);
    if (overlay) overlay.addEventListener("click", dismissPopup);

    if (form) {
      form.addEventListener("submit", function () {
        localStorage.setItem("ironvx-email-captured", "submitted");
      });
    }

    // Auto-trigger after 5 seconds
    setTimeout(function () {
      if (localStorage.getItem("ironvx-email-captured")) return;
      popup.classList.remove("hidden");
      popup.offsetHeight; // Force layout reflow
      popup.classList.add("is-visible");
    }, 5000);
  }

  function initReviewsSection() {
    var writeBtn = $("#ironvx-write-review-btn");
    var modal = $("#ironvx-review-modal");
    if (!modal) return;

    var overlay = $("#ironvx-review-modal-overlay");
    var closeBtn = $("#ironvx-review-modal-close");
    var form = $("#ironvx-review-submission-form");
    var starBtns = $$(".rev-star-btn", modal);
    var selectedRating = 5;

    function openModal() {
      modal.classList.remove("hidden");
      modal.offsetHeight;
      modal.classList.add("is-visible");
    }

    function closeModal() {
      modal.classList.remove("is-visible");
      setTimeout(function () {
        modal.classList.add("hidden");
      }, 400);
    }

    if (writeBtn) writeBtn.addEventListener("click", openModal);
    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    if (overlay) overlay.addEventListener("click", closeModal);

    // Rating star selector behavior
    starBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        selectedRating = Number(btn.getAttribute("data-rating"));
        starBtns.forEach(function (star, idx) {
          if (idx < selectedRating) {
            star.classList.remove("text-muted-foreground");
            star.classList.add("text-accent");
          } else {
            star.classList.remove("text-accent");
            star.classList.add("text-muted-foreground");
          }
        });
      });
    });

    // Form submission
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        showToast("Review submitted successfully! Thank you.");
        closeModal();
        form.reset();
        
        starBtns.forEach(function (star, idx) {
          if (idx < 5) {
            star.classList.remove("text-muted-foreground");
            star.classList.add("text-accent");
          } else {
            star.classList.remove("text-accent");
            star.classList.add("text-muted-foreground");
          }
        });
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    fixIronvxNavLinks();
    initCountdown();
    initMobileMenu();
    initLocaleMenu();
    initProductPage();
    initStickyBar();
    initCartPage();
    initBlog();
    refreshCartCount();
    initIronvxLocale();
    initEmailPopup();
    initReviewsSection();
  });
})();
